/**
 * @generated SignedSource<<2510ad9ea25de3af22a0dc6752001db0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SignalDetailRegisterAsSeenMutation$variables = {
  signalId: string;
};
export type SignalDetailRegisterAsSeenMutation$data = {
  readonly signal: {
    readonly registerEmployeeReceiverReceipt: {
      readonly employeeReceiverReceipts: ReadonlyArray<{
        readonly employeeId: string | null;
        readonly openedAtDate: {
          readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
        };
        readonly signalWorkspaceId: string;
      }>;
      readonly employeeReceiverReceiptsCount: number;
      readonly id: string;
      readonly opened: boolean;
    };
  };
};
export type SignalDetailRegisterAsSeenMutation = {
  response: SignalDetailRegisterAsSeenMutation$data;
  variables: SignalDetailRegisterAsSeenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "signalId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "signalId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "opened",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "employeeReceiverReceiptsCount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signalWorkspaceId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "employeeId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SignalDetailRegisterAsSeenMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SignalMutation",
        "kind": "LinkedField",
        "name": "signal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Signal",
            "kind": "LinkedField",
            "name": "registerEmployeeReceiverReceipt",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SignalEmployeeReceiverReceipt",
                "kind": "LinkedField",
                "name": "employeeReceiverReceipts",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnzonedDate",
                    "kind": "LinkedField",
                    "name": "openedAtDate",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "FormattedDate"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SignalDetailRegisterAsSeenMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SignalMutation",
        "kind": "LinkedField",
        "name": "signal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Signal",
            "kind": "LinkedField",
            "name": "registerEmployeeReceiverReceipt",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SignalEmployeeReceiverReceipt",
                "kind": "LinkedField",
                "name": "employeeReceiverReceipts",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnzonedDate",
                    "kind": "LinkedField",
                    "name": "openedAtDate",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isoString",
                            "storageKey": null
                          }
                        ],
                        "type": "Date",
                        "abstractKey": "__isDate"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e9c28870c18f73cc68577da44cab478c",
    "id": null,
    "metadata": {},
    "name": "SignalDetailRegisterAsSeenMutation",
    "operationKind": "mutation",
    "text": "mutation SignalDetailRegisterAsSeenMutation(\n  $signalId: ID!\n) {\n  signal(id: $signalId) {\n    registerEmployeeReceiverReceipt {\n      id\n      opened\n      employeeReceiverReceiptsCount\n      employeeReceiverReceipts {\n        signalWorkspaceId\n        employeeId\n        openedAtDate {\n          ...FormattedDate\n        }\n      }\n    }\n  }\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "a8ace2934c8a48c7329b9ea58e144371";

export default node;
